// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__lN3f2","sectionIcon":"SectionHeader_sectionIcon__0C1k3"};